module.exports = __webpack_public_path__ + "assets/img/block-left-378e058f.png";